import { useEffect, useRef } from "react";
import { useColorScheme } from "@mui/material/styles";

// The favicon carries both a light and a dark artwork, switched by a media
// query. Picking a scheme in the app has to override that by hand.
export function useFavicon() {
  const { mode } = useColorScheme();
  const svgCacheRef = useRef(null);
  const blobUrlRef = useRef(null);

  useEffect(() => {
    const link = document.getElementById("favicon-svg");
    if (!link) return;

    const cleanup = () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
        blobUrlRef.current = null;
      }
    };

    if (mode === "system") {
      cleanup();
      link.href = "/favicon.svg";
      return cleanup;
    }

    const updateFavicon = async () => {
      if (!svgCacheRef.current) {
        const response = await fetch("/favicon.svg");
        svgCacheRef.current = await response.text();
      }

      const forcedCss =
        mode === "dark"
          ? "#light-icon { display: none; } #dark-icon { display: inline; }"
          : "#light-icon { display: inline; } #dark-icon { display: none; }";

      const modifiedSvg = svgCacheRef.current.replace(
        /<style>[\s\S]*?<\/style>/,
        `<style>${forcedCss}</style>`,
      );

      cleanup();
      const blob = new Blob([modifiedSvg], { type: "image/svg+xml" });
      blobUrlRef.current = URL.createObjectURL(blob);
      link.href = blobUrlRef.current;
    };

    updateFavicon();
    return cleanup;
  }, [mode]);
}
